import _ from 'lodash';
import { createAction } from 'redux-actions';

const OPEN_DIALOG = 'viewDesigns/templates/OPEN_DIALOG';
const HIDE_DIALOG = 'viewDesigns/templates/HIDE_DIALOG';
const UPDATE_TEMPLATE = 'viewDesigns/templates/UPDATE_TEMPLATE';
const UPDATE_ALL_TEMPLATES = 'viewDesigns/templates/UPDATE_ALL_TEMPLATES';

const UPDATE_FOLDERS_TEMPLATES = 'viewTemplates/UPDATE_FOLDERS_TEMPLATES';
const PUSH_NEW_TEMPLATE = 'viewTemplates/PUSH_NEW_TEMPLATE';
const REPLACE_TEMPLATE = 'viewTemplates/REPLACE_TEMPLATE';
const REMOVE_TEMPLATES = 'viewTemplates/REMOVE_TEMPLATES';
const MOVE_TEMPLATES_TO_HOME = 'viewTemplates/MOVE_TEMPLATES_TO_HOME';
const MOVE_TEMPLATES_TO_FOLDER = 'viewTemplates/MOVE_TEMPLATES_TO_FOLDER';
const SET_SELECTED_IDS = 'viewTemplates/SET_SELECTED_IDS';
const PUSH_SELECTED_ID = 'viewTemplates/PUSH_SELECTED_ID';
const REMOVE_SELECTED_ID = 'viewTemplates/REMOVE_SELECTED_ID';
const OPEN_SNACKBAR = 'viewTemplates/OPEN_SNACKBAR';
const HIDE_SNACKBAR = 'viewTemplates/HIDE_SNACKBAR';
const UPDATE_PREFETCHED_TEMPLATES = 'viewTemplates/UPDATE_PREFETCHED_TEMPLATES';
const UPDATE_DEFAULT_TEMPLATE = 'viewTemplates/UPDATE_DEFAULT_TEMPLATE';
import update from 'immutability-helper';

let templates = [];

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        openedDialog: action.dialogName,
        currentTemplate: action.template
      };
    case HIDE_DIALOG:
      return {
        ...state,
        openedDialog: '',
        currentTemplate: ''
      };
    case UPDATE_TEMPLATE:
      return {
        ...state,
        templateList: {
          ...state.templateList,
          [action.template.id]: {...(state.templateList[action.template.id]), ...action.template}
        }
      };
    case UPDATE_ALL_TEMPLATES:
      const newTemplateList = {};
      _.forEach(state.templateList, (template) => {
        newTemplateList[template.id] = {...template, ...action.update};
      });
      return {
        ...state,
        templateList: newTemplateList
      };

    case UPDATE_FOLDERS_TEMPLATES:
      return {
        ...state,
        userTemplates: Object.assign({}, state.userTemplates, {[action.payload.id]: action.payload.templates}),
      };
    case PUSH_NEW_TEMPLATE:
      templates = Object.assign({}, state.userTemplates);
      templates[action.payload.folder] = [action.payload.template, ...templates[action.payload.folder]];
      return {
        ...state,
        userTemplates: templates,
      };
    case REPLACE_TEMPLATE: {
      const userTemplates = Object.assign({}, state.userTemplates);
      const { folder, template: {id, name } } = action.payload;
      userTemplates[folder] = state.userTemplates[folder].map((item) => {
        const item1 = Object.assign({}, item);
        if (item.id === id) {
          item1.name = name;
        }
        return item1;
      });
      return {
        ...state,
        userTemplates,
      };
    }
    case REMOVE_TEMPLATES: {
      const { folderId, templatesIdArray } = action.payload;
      const userTemplates = Object.assign({}, state.userTemplates);
      userTemplates[folderId] = userTemplates[folderId] ? userTemplates[folderId] : [];
      userTemplates[folderId] = userTemplates[folderId].filter((item) => templatesIdArray.indexOf(item.id) === -1);
      return {
        ...state,
        userTemplates,
        selectedTemplates: [],
      };
    }
    case MOVE_TEMPLATES_TO_HOME:
      templates = Object.assign({}, state.userTemplates);
      Object.assign(templates['0'], templates[action.payload.id]);
      _.pullAt(templates, action.payload.id);
      return {
        ...state,
        userTemplates: templates,
        selectedTemplates: [],
      };
    case MOVE_TEMPLATES_TO_FOLDER: {
      const { sourceFolderId, destFolderId, templatesIdArray } = action.payload;
      const userTemplates = Object.assign({}, state.userTemplates);
      const selectedTemplates = [];
      const rest = [];
      userTemplates[sourceFolderId].map((item) => {
        if (templatesIdArray.indexOf(item.id) !== -1) {
          selectedTemplates.push(item);
        } else {
          rest.push(item);
        }
      });
      if (userTemplates[destFolderId] === undefined) {
        userTemplates[destFolderId] = [];
      }
      userTemplates[destFolderId] = userTemplates[destFolderId].concat(selectedTemplates);
      userTemplates[sourceFolderId] = rest;
      return {
        ...state,
        userTemplates,
        selectedTemplates: [],
      };
    }
    case SET_SELECTED_IDS: {
      return {
        ...state,
        selectedTemplates: action.payload,
      };
    }
    case PUSH_SELECTED_ID: {
      return {
        ...state,
        selectedTemplates: state.selectedTemplates.concat(action.payload),
      };
    }
    case REMOVE_SELECTED_ID: {
      return {
        ...state,
        selectedTemplates: state.selectedTemplates.filter((item) => item !== action.payload),
      };
    }
    case OPEN_SNACKBAR:
      return {
        ...state,
        snackbarData: {
          ...action.payload,
          open: true,
        },
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        snackbarData: {
          open: false,
          message: '',
        },
      };
    case UPDATE_PREFETCHED_TEMPLATES:
      return update(state, {
        prefetchedTemplates: {$apply: prefetchedTemplates => {
          const index = _.findIndex(state.prefetchedTemplates, {id: action.payload.id});
          if (index === -1) {
            return [...prefetchedTemplates, action.payload];
          }
          const clone = _.clone(prefetchedTemplates);
          clone[index] = action.payload;
          return clone;
        }},
      });
    case UPDATE_DEFAULT_TEMPLATE:
      const templateData = action.payload;
      return update(state, {userTemplates: {default: {$set: {name: templateData['clData.templateName'], id: templateData['clData.templateId'], previewUrl: templateData['clData.templatePreviewUrl']}}}});
    default:
      return state;
  }
}

export function openDialog(dialogName, template, dialogData) {
  return {type: OPEN_DIALOG, dialogName, template, dialogData};
}

export function hideDialog() {
  return {type: HIDE_DIALOG};
}

export function updateTemplate(template) {
  return {type: UPDATE_TEMPLATE, template};
}

export function updateAllTemplates(update) {
  return {type: UPDATE_ALL_TEMPLATES, update: update};
}

export const updateFolderTemplates = createAction(UPDATE_FOLDERS_TEMPLATES);
export const pushNewTemplate = createAction(PUSH_NEW_TEMPLATE);
export const replaceTemplate = createAction(REPLACE_TEMPLATE);
export const removeTemplates = createAction(REMOVE_TEMPLATES);
export const moveTemplatesToHome = createAction(MOVE_TEMPLATES_TO_HOME);
export const moveTemplatesToFolder = createAction(MOVE_TEMPLATES_TO_FOLDER);
export const setSelectedId = createAction(SET_SELECTED_IDS);
export const pushSelectedId = createAction(PUSH_SELECTED_ID);
export const removeSelectedId = createAction(REMOVE_SELECTED_ID);
export const openSnackbar = createAction(OPEN_SNACKBAR);
export const hideSnackbar = createAction(HIDE_SNACKBAR);
export const updatePrefetchedTemplates = createAction(UPDATE_PREFETCHED_TEMPLATES);
export const updateDefaultTemplate = createAction(UPDATE_DEFAULT_TEMPLATE);

export const unselectAllIds = () => setSelectedId([]);
